"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.natalie.description': 'Americana amable e inteligente perfecta para narración.',
};
